import { render, staticRenderFns } from "./leads.vue?vue&type=template&id=f985e422"
import script from "./leads.vue?vue&type=script&lang=js"
export * from "./leads.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports